import React, { useState, useEffect } from "react";
import "./HistoryComponent.css";
import { useNavigate } from "react-router-dom";

const HistoryComponent = ({ socket }) => {
    const navigate = useNavigate();
    const [historyData, setHistoryData] = useState([]);

    // Функция для сокращения адреса
    const shortenAddress = (address) => {
        if (!address || address.length < 4) return address; // Если адрес слишком короткий, возвращаем его без изменений
        return `${address.slice(0, 2)}...${address.slice(-2)}`;
    };

    useEffect(() => {
        if (socket) {
            // Запрашиваем данные из таблицы owners при подключении
            socket.emit('get_owners_data');

            // Слушаем событие для получения данных из таблицы owners
            socket.on('owners_data', (data) => {

                // Обрабатываем данные: сокращаем адреса и добавляем количество usernames и numbers
                const processedData = data.map((item) => ({
                    ...item,
                    address: shortenAddress(item.address), // Сокращаем адрес
                    usernamesCount: item.usernames.split(", ").length, // Количество usernames
                    numbersCount: item.numbers.split(", ").length, // Количество numbers
                }));

                setHistoryData(processedData);
            });

            // Слушаем событие для получения новых данных в реальном времени
            socket.on('new_owner_item', (newItem) => {

                // Обрабатываем новый элемент: сокращаем адрес и добавляем количество usernames и numbers
                const processedItem = {
                    ...newItem,
                    address: shortenAddress(newItem.address), // Сокращаем адрес
                    usernamesCount: newItem.usernames.split(", ").length, // Количество usernames
                    numbersCount: newItem.numbers.split(", ").length, // Количество numbers
                };

                setHistoryData((prev) => [...prev, processedItem]);
            });
        }

        return () => {
        };
    }, [socket]);

    const handleMarkAsRead = (itemId) => {
        socket.emit('mark_as_read', itemId, (response) => {
            if (response.success) {
                console.log("Marked as read successfully");
            } else {
                console.error("Failed to mark as read:", response.message);
            }
        });
    };

    return (
        <div className="mainContainer">
            <div className="wrapper">
                <div className="mainHistoryContainer">
                    <span className="title">PARSER</span>
                    <div className="historyContainer">
                        <span className="titleParsing">History</span>

                        <div className="historyList">
                            {historyData.map((item) => (
                                <div
                                    className={`historyItem ${item.isRead ? 'historyItemRead' : ''}`}
                                    key={item.id}
                                >
                                    <div className="historyItemInfo">
                                        <span className="historyItemAddress">
                                            {item.address} | {item.balance}TON = {item.usdt_balance}$
                                        </span>
                                        <span
                                            className={`historyItemUsername ${
                                                item.isRead ? 'historyItemUsernameRead' : ''
                                            }`}
                                        >
                                            @username <span className="mutedValues">— {item.usernamesCount}</span> {" "}
                                            
                                            | +888 <span className="mutedValues">— {item.numbersCount}</span>
                                            
                                        </span>
                                    </div>
                                    <button
                                        className="openButton"
                                        onClick={() => navigate(`/history/${item.id}`)}
                                    >
                                        Open
                                    </button>
                                </div>
                            ))}
                        </div>
                        <button className="backButton" onClick={() => navigate('/profile')}>Back</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HistoryComponent;